'use strict';

angular.module('controllers')
        .directive('focusField', ['$compile', '$parse', '$timeout', '$rootScope', function($compile, $parse, $timeout, $rootScope) {
		var timer = null;
		return {
			restrict: 'A',
			link: function (scope, element, attr, ctrl) {
				//console.log(element);
				element.bind('mousemove', function (ev) {
					element.closest('md-card').attr('draggable', false);
				});
				element.bind('mouseleave', function (ev) {
					element.closest('md-card').attr('draggable', true);
				});
				element.bind('focus', function (ev) {
                                        $rootScope.focusedElement = element;
					element.closest('md-card').attr('draggable', false);
				});
				element.bind('blur', function (ev) {
					element.closest('md-card').attr('draggable', true);
				});
			}
		}
		}])
